const Palanquita = ({title, active, disabled, onToggle}) => {
  return (
    <div className="palanquita">
      <button disabled={disabled} className={"palanquita__button" + (active ? ' is--active' : '')} title={title} onClick={onToggle}></button>
    </div>
  )
}

export default Palanquita;